import {Error,ErrorProps, WarningProps, Warning} from "@npd-ng/adp-benchmark";
import errorIcon from '../assets/error_icon.svg';
export default function ErrorLoadinfView() {
 const warning = true;
 const deviceReadiness = {
    "title": "Error - System Error",
    "code": "000",
    "message": "An error has been encountered and the application has stopped working. <br/>Please <strong>exit the application</strong> and try again.<br/>If problems persist, please contact the NAEP Help Desk"
 }
 const warningMsg = {
  "code": "Error code: 000",
  "title": "Failed to load the application.",
  "message": "An error has been encountered and the application has stopped working.<br/>Please try again. If problems persist, please contact the NAEP Help Desk"
}
  const errorProps: ErrorProps = {
    error:{
      iconSrc: errorIcon,
      title: deviceReadiness.title,
      message: deviceReadiness.message,
      buttons:[{
          label: "Exit Application",
          action:()=>{window.close()},
          variant: "secondary"
      }]}
    }
    const warningProps: WarningProps = {
      errorCode: "",
      title: warningMsg.title,
      message: warningMsg.message,
      buttons:[{
        label: "Try Again",
        action:()=>{window.location.reload()},
        variant: "primary"
    },{
          label: "Exit Application",
          action:()=>{window.close()},
          variant: "secondary"
      }, ]
    }
  return (
    <>
       <div className="fixedHeight" />
       <div style={{padding:"100px"}}>
       {warning ? <Warning {...warningProps}/> :<Error {...errorProps}/>}
       </div>
       </> 
  )
}
